/**
 * Shared layout components for all pages.
 * Import from '@/layout' for consistent page shell: TopBar, TopNavBar, main content, Footer.
 */
export { default as Footer } from '../views/home/components/Footer';
export { default as TopNavBar } from '../views/home/components/TopNavBar';
export { default as TopBar } from '../components/TopBar';
